import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const selector: ThemeUICSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  height: '100vh',
  justifyContent: 'center',
  maxWidth: 'min(500px, 90vw)',

  '.selector__options': {
    display: 'flex',
    justifyContent: 'space-evenly',
    gap: 3,
  },

  '.selector__option__classic': {
    variant: 'buttons.outline',
  },

  '.selector__links': {
    textAlign: 'center',
  },

  '.selector__link__back': {
    variant: 'buttons.link',
  },
};

export default selector;
